import { Locale, type LocalizedString } from "../Locale.js";
import type { Tenant } from "../Tenant.js";
import { getPathInLocale } from "./getPathInLocale.js";

const pathMap: LocalizedString = {
	[Locale.cs]: "/projekty",
	[Locale.en]: "/projects",
	[Locale.sk]: "/projekty",
};

const slugPrefix: LocalizedString = {
	[Locale.cs]: "projekt",
	[Locale.en]: "project",
	[Locale.sk]: "projekt",
};

export function getEuProjektDetailPath(tenant: Tenant, projectId: string): string {
	const basePath = getPathInLocale(tenant.locale, pathMap);
	const prefix = slugPrefix[tenant.locale];
	return `${basePath}/${prefix}-${projectId}`;
}
